export default __webpack_public_path__ + "static/media/hana.4fb73427.png";